// extracted by mini-css-extract-plugin
export default {"tabWrapper":"style_tabWrapper__-UqeN","number":"style_number__1X847"};